import { render, staticRenderFns } from "./significance_report.vue?vue&type=template&id=48fed63f"
import script from "./significance_report.vue?vue&type=script&lang=js"
export * from "./significance_report.vue?vue&type=script&lang=js"
import style0 from "./significance_report.vue?vue&type=style&index=0&id=48fed63f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports